"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var Subject_1 = require("rxjs/Subject");
require("./table-with-bulk-picker-settings.component.scss");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var Observable_1 = require("rxjs/Observable");
var of_1 = require("rxjs/observable/of");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var custom_draggable_column_model_1 = require("../model/custom-draggable-column-model");
var custom_table_action_provider_service_1 = require("../../../shared/services/api/custom-table-action-provider.service");
var selected_main_entity_info_1 = require("../model/selected-main-entity-info");
var table_button_config_component_1 = require("./settings-components/table-button-config/table-button-config.component");
var table_type_1 = require("../enums/table-type");
var TableWithBulkPickerSettingsComponent = /** @class */ (function (_super) {
    __extends(TableWithBulkPickerSettingsComponent, _super);
    function TableWithBulkPickerSettingsComponent(kbService, communicationService, classifierService, formManagementService, messageService, customTableActionProviderService) {
        var _this = _super.call(this, communicationService) || this;
        _this.kbService = kbService;
        _this.communicationService = communicationService;
        _this.classifierService = classifierService;
        _this.formManagementService = formManagementService;
        _this.messageService = messageService;
        _this.customTableActionProviderService = customTableActionProviderService;
        _this.fields = {};
        _this.isReady = false;
        _this.FormType = idm_dynamic_layout_interpreter_1.FormType;
        _this.TableType = table_type_1.TableType;
        _this.hasCustomButtons = false;
        _this.useSameSearchSettings = true;
        _this.selectedCustomTableActions = [];
        _this.classifierCache = new Map();
        _this.subFieldModels = [];
        _this.tableDragulaOptions = new idm_dynamic_forms_controls_1.TableDragulaOptions();
        _this.metaFieldTypes = idm_kb_service_client_js_1.MetaFieldType;
        _this._state = {};
        _this.subEntityMetaFields = [];
        _this.selectedSubEntityMetaFields = [];
        _this.selectedSubEntityLookupMetaFields = [];
        _this.mainEntityMetaFields = [];
        _this.customTableActions = [];
        _this.selectedMainEntity = new selected_main_entity_info_1.SelectedMainEntityInfo();
        _this.selectedTableType = 0;
        _this.buttonConfigs = [];
        _this._colSystemNames = [];
        _this._cachedSubEntityMetaFields = new Map();
        _this._destroy$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(TableWithBulkPickerSettingsComponent.prototype, "state", {
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    TableWithBulkPickerSettingsComponent.prototype.ngOnChanges = function (changes) {
        if (changes.state && changes.state.previousValue
            && !(changes.state.currentValue.colSystemNames === changes.state.previousValue.colSystemNames)) {
            this._colSystemNames = changes.state.currentValue.colSystemNames;
            this.checkForUsedFields();
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var metaFields$ = this.kbService
            .getMetaFields(this.category)
            .pipe(operators_1.concatMap(function (metaFields) {
            var subEntityFields = metaFields.filter(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY; });
            var innerFieldObservables$ = subEntityFields.map(function (metaField) { return _this.kbService.getMetaFields(metaField.getCompoundCategorySystemName()).map(function (fields) { return ({ metaField: metaField, fields: fields }); }); });
            return Observable_1.Observable.zip.apply(Observable_1.Observable, innerFieldObservables$);
        }));
        var defaultButtonTitle$ = this.messageService.getMessage('ejustice_add');
        Observable_1.Observable.zip(metaFields$, defaultButtonTitle$)
            .takeUntil(this._destroy$)
            .subscribe(function (_a) {
            var metaFields = _a[0], defaultButtonTitle = _a[1];
            metaFields.forEach(function (_a) {
                var metaField = _a.metaField, fields = _a.fields;
                _this._cachedSubEntityMetaFields.set(metaField.getSystemName(), fields);
                if (fields.some(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY; })) {
                    _this.subEntityMetaFields.push(metaField);
                }
            });
            _this.defaultButtonTitle = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map().set(_this.currentLanguageId, defaultButtonTitle));
            _this.prepareState();
        });
        this.communicationService.peerSubject.pipe(operators_1.filter(function (data) { return data.key === idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW; }), operators_1.takeUntil(this._destroy$)).subscribe(function () {
            _this.handleConfigChanges();
        });
    };
    TableWithBulkPickerSettingsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    TableWithBulkPickerSettingsComponent.prototype.onMetaFieldSelect = function (selectedMetaField) {
        var _this = this;
        this.selectedSubEntityMetaField = selectedMetaField;
        if (this.selectedSubEntityMetaField) {
            this.label = selectedMetaField.getDisplayNameMultilingual();
            this.selectedSubEntityMetaFields = this._cachedSubEntityMetaFields.get(selectedMetaField.getMetaFieldId().getSystemName());
            this.selectedSubEntityLookupMetaFields = this.selectedSubEntityMetaFields.filter(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER; });
            this.mainEntityMetaFields = this.selectedSubEntityMetaFields.filter(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY; });
            var forms$ = this.formManagementService.loadFormsByCategoryAndType(this.category, idm_dynamic_layout_interpreter_1.FormType.EDIT);
            var customTableActions$ = this.customTableActionProviderService ?
                this.customTableActionProviderService.getCustomTableActions(this.category, selectedMetaField.getSystemName())
                :
                    of_1.of([]);
            Observable_1.Observable.zip(forms$, customTableActions$, this.setFieldModels())
                .pipe(operators_1.takeUntil(this._destroy$))
                .subscribe(function (_a) {
                var forms = _a[0], customTableActions = _a[1];
                _this.categoryForms = forms.filter(function (form) { return form.subCategorySystemName === selectedMetaField.getCompoundCategorySystemName(); });
                _this.customTableActions = customTableActions;
            });
        }
        else {
            this.label = null;
            this.selectedMainEntity = new selected_main_entity_info_1.SelectedMainEntityInfo();
            this.selectedSubEntityMetaFields = [];
            this.selectedSubEntityLookupMetaFields = [];
            this.mainEntityMetaFields = [];
            this.categoryForms = [];
            this.customTableActions = [];
            this.subFieldModels = [];
        }
        this.communicationService.peerSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, []));
        this.controlLabel = {};
        this.selectedMainEntityMetaField = null;
        this.selectedCustomTableActions = [];
        this._colSystemNames = [];
        this.setDefaultButtons();
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onMainEntitySelect = function (mainEntityMetaField) {
        var _this = this;
        this.selectedMainEntityMetaField = mainEntityMetaField;
        this.selectedMainEntity = new selected_main_entity_info_1.SelectedMainEntityInfo();
        if (this.selectedMainEntityMetaField) {
            this.buttonConfigs = this.hasCustomButtons ? [] : [this.defaultButtonConfig];
            var metaFields$ = this.kbService.getMetaFields(mainEntityMetaField.getCompoundCategorySystemName());
            var displayNameFields$ = this.kbService.getNameMetaFieldIds(mainEntityMetaField.getCompoundCategorySystemName());
            Observable_1.Observable.zip(metaFields$, displayNameFields$)
                .takeUntil(this._destroy$)
                .subscribe(function (_a) {
                var metaFields = _a[0], displayNames = _a[1];
                _this.setMainEntityFields(metaFields, displayNames);
                _this.setDefaultButtons();
            });
        }
        else {
            this.setDefaultButtons();
        }
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onCustomButtonsRadioChange = function (hasCustomButtons) {
        this.hasCustomButtons = hasCustomButtons.value;
        this.setDefaultButtons();
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onSelectedTableTypeSelect = function (selectedTableType) {
        this.selectedTableType = selectedTableType.value;
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onSameSearchSettingsRadioChange = function (useSameSearchSettings) {
        this.useSameSearchSettings = useSameSearchSettings.value;
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onImageFieldSelect = function (imageFieldSystemName) {
        this.mainEntityImageFieldName = imageFieldSystemName;
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onGroupByFieldSelect = function (groupByMetaField) {
        this.selectedGroupByMetaField = groupByMetaField;
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onEditFormIdSelect = function (formId) {
        this.editFormId = formId;
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.onCustomTableActionsSelect = function (customTableActions) {
        this.selectedCustomTableActions = customTableActions;
        this.handleConfigChanges();
    };
    TableWithBulkPickerSettingsComponent.prototype.trackByFieldModelsIds = function (index, subFieldModel) {
        return subFieldModel.id;
    };
    TableWithBulkPickerSettingsComponent.prototype.prepareState = function () {
        var _this = this;
        if (this._state) {
            this.setStateValues();
            if (!this.hasCustomButtons && !this.buttonConfigs.length) {
                this.buttonConfigs = [this.defaultButtonConfig];
            }
            if (this.fields.field) {
                var selectedSubEntitySystemName_1 = this.fields.field['metaFieldId']['systemName'];
                this.selectedSubEntityMetaField = this.subEntityMetaFields.find(function (field) { return field.getSystemName() === selectedSubEntitySystemName_1; });
                this.selectedSubEntityMetaFields = this._cachedSubEntityMetaFields.get(this.selectedSubEntityMetaField['metaFieldId']['systemName']);
                this.selectedSubEntityLookupMetaFields = this.selectedSubEntityMetaFields.filter(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER; });
                this.mainEntityMetaFields = this.selectedSubEntityMetaFields.filter(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY; });
                this.checkForSelectedMainEntityMetaField();
                this.checkForSelectedGroupByMetaField();
                var selectedMainEntityMetaFields$ = this.selectedMainEntityMetaField ?
                    this.kbService.getMetaFields(this.selectedMainEntityMetaField.getCompoundCategorySystemName()) : of_1.of([]);
                var selectedMainEntityNameFields$ = this.selectedMainEntityMetaField ?
                    this.kbService.getNameMetaFieldIds(this.selectedMainEntityMetaField.getCompoundCategorySystemName()) : of_1.of([]);
                var setFieldModels$ = this.selectedSubEntityMetaField ?
                    this.setFieldModels() : of_1.of(null);
                var forms$ = this.formManagementService.loadFormsByCategoryAndType(this.category, idm_dynamic_layout_interpreter_1.FormType.EDIT);
                var customTableActions$ = this.customTableActionProviderService ?
                    this.customTableActionProviderService.getCustomTableActions(this.category, selectedSubEntitySystemName_1)
                    :
                        of_1.of([]);
                Observable_1.Observable.zip(selectedMainEntityMetaFields$, selectedMainEntityNameFields$, forms$, customTableActions$, setFieldModels$)
                    .pipe(operators_1.concatMap(function (_a) {
                    var selectedMainEntityMetaFields = _a[0], selectedMainEntityNameFields = _a[1], subEntityForms = _a[2], customTableActions = _a[3];
                    if (selectedMainEntityMetaFields) {
                        _this.setMainEntityFields(selectedMainEntityMetaFields, selectedMainEntityNameFields);
                    }
                    _this.categoryForms = subEntityForms
                        .filter(function (form) { return form.subCategorySystemName === _this.selectedSubEntityMetaField.getCompoundCategorySystemName(); });
                    _this.customTableActions = customTableActions;
                    _this.checkForSelectedCustomTableActions();
                    var classifiers$ = [];
                    // Loads classifiers for each button config's filter and default value
                    _this.buttonConfigs.forEach(function (buttonConfig) {
                        buttonConfig.title = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(buttonConfig.stringTitle)));
                        if (buttonConfig.searchFilter && buttonConfig.searchFilter.lookupFieldSystemName) {
                            classifiers$.push(_this.classifierService.loadAllClassifiers(buttonConfig.searchFilter.lookupFieldCompoundName)
                                .map(function (classifiersResponse) { return ({
                                compoundName: buttonConfig.searchFilter.lookupFieldCompoundName,
                                classifiers: classifiersResponse.getData()
                            }); }));
                        }
                        if (buttonConfig.defaultValues && buttonConfig.defaultValues.defaultValueFieldSystemName) {
                            classifiers$.push(_this.classifierService.loadAllClassifiers(buttonConfig.defaultValues.defaultValueFieldCompoundName)
                                .map(function (classifiersResponse) { return ({
                                compoundName: buttonConfig.defaultValues.defaultValueFieldCompoundName,
                                classifiers: classifiersResponse.getData()
                            }); }));
                        }
                    });
                    _this.defaultButtonConfig.title = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(_this.defaultButtonConfig.stringTitle)));
                    _this.selectedMainEntity.metaFields.forEach(function (metaField) {
                        _this.buttonConfigs.forEach(function (buttonConfig) {
                            _this.overrideMetaFieldIdReferences(buttonConfig, metaField, true);
                        });
                        _this.overrideMetaFieldIdReferences(_this.defaultButtonConfig, metaField, true);
                    });
                    _this.selectedSubEntityMetaFields.forEach(function (metaField) {
                        _this.buttonConfigs.forEach(function (buttonConfig) {
                            _this.overrideMetaFieldIdReferences(buttonConfig, metaField, false);
                        });
                        _this.overrideMetaFieldIdReferences(_this.defaultButtonConfig, metaField, false);
                    });
                    return classifiers$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, classifiers$) : of_1.of([]);
                }), operators_1.takeUntil(this._destroy$))
                    .subscribe(function (classifiersData) {
                    classifiersData.forEach(function (classifierData) {
                        return _this.classifierCache.set(classifierData.compoundName, classifierData.classifiers);
                    });
                    _this.isReady = true;
                });
            }
            else {
                this.buttonConfigs.map(function (buttonConfig) {
                    if (buttonConfig.stringTitle) {
                        buttonConfig.title = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(buttonConfig.stringTitle)));
                    }
                });
                this.defaultButtonConfig.title = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(this.defaultButtonConfig.stringTitle)));
                this.isReady = true;
            }
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.checkForSelectedMainEntityMetaField = function () {
        var _this = this;
        if (this.selectedMainEntityMetaField) {
            this.selectedMainEntityMetaField = this.mainEntityMetaFields.find(function (field) { return field.getSystemName() ===
                _this.selectedMainEntityMetaField['metaFieldId']['systemName']; });
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.checkForSelectedGroupByMetaField = function () {
        var _this = this;
        if (this.selectedGroupByMetaField) {
            this.selectedGroupByMetaField = this.selectedSubEntityMetaFields.find(function (field) { return field.getSystemName() ===
                _this.selectedGroupByMetaField['metaFieldId']['systemName']; });
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.checkForSelectedCustomTableActions = function () {
        var _this = this;
        if (this.selectedCustomTableActions.length) {
            this.selectedCustomTableActions = this.customTableActions.filter(function (action) {
                return _this.selectedCustomTableActions.some(function (selectedAction) { return selectedAction.actionKey === action.actionKey; });
            });
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.handleConfigChanges = function () {
        var _this = this;
        if (this.hasCustomButtons) {
            this.buttonConfigs.forEach(function (buttonConfig) {
                if (_this.useSameSearchSettings) {
                    buttonConfig.searchKeywords = _this.defaultButtonConfig.searchKeywords;
                    buttonConfig.hasCreateButton = _this.defaultButtonConfig.hasCreateButton;
                    buttonConfig.filterFields = _this.defaultButtonConfig.filterFields;
                    buttonConfig.columns = _this.defaultButtonConfig.columns;
                    buttonConfig.subFormId = _this.defaultButtonConfig.subFormId;
                    buttonConfig.selectedItemFields = _this.defaultButtonConfig.selectedItemFields;
                }
                buttonConfig.fieldsToLoad = _this.getFieldsToLoad(buttonConfig);
                return buttonConfig;
            });
        }
        else {
            this.buttonConfigs = [this.defaultButtonConfig];
            this.defaultButtonConfig.fieldsToLoad = this.getFieldsToLoad(this.defaultButtonConfig);
        }
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            fields: this.selectedSubEntityMetaField ? {
                field: this.selectedSubEntityMetaField,
            } : {},
            state: {
                label: this.label ? JSON.stringify(Array.from(this.label.toMap().entries())) : null,
                mainEntityMetaField: this.selectedMainEntityMetaField,
                tableType: this.selectedTableType,
                groupByMetaField: this.selectedGroupByMetaField,
                buttonConfigs: this.buttonConfigs,
                showDeleteButton: this.showDeleteButton,
                hasCustomButtons: this.hasCustomButtons,
                useSameSearchSettings: this.useSameSearchSettings,
                mainEntityImageFieldName: this.mainEntityImageFieldName,
                customTableActions: this.selectedCustomTableActions,
                editFormId: this.editFormId,
                defaultButtonConfig: this.useSameSearchSettings ? this.defaultButtonConfig : null,
                configured: this.isConfiguredCorrectly()
            },
        }));
    };
    TableWithBulkPickerSettingsComponent.prototype.setMainEntityFields = function (metaFields, displayNameMetaFieldIds) {
        var _this = this;
        this.selectedMainEntity.metaFields = metaFields;
        this.selectedMainEntity.lookupFields = [];
        this.selectedMainEntity.textFields = [];
        this.selectedMainEntity.filterFields = [];
        this.selectedMainEntity.columnFields = [];
        this.selectedMainEntity.documentFields = [];
        this.selectedMainEntity.nameMetaFieldIds = [];
        metaFields.forEach(function (metaField) {
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.STRING || metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
                _this.selectedMainEntity.textFields.push(metaField);
                _this.selectedMainEntity.filterFields.push(metaField);
                _this.selectedMainEntity.columnFields.push(metaField);
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
                _this.selectedMainEntity.lookupFields.push(metaField);
                _this.selectedMainEntity.filterFields.push(metaField);
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE) {
                _this.selectedMainEntity.lookupFields.push(metaField);
                _this.selectedMainEntity.filterFields.push(metaField);
                _this.selectedMainEntity.columnFields.push(metaField);
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER) {
                _this.selectedMainEntity.lookupFields.push(metaField);
                _this.selectedMainEntity.columnFields.push(metaField);
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE) {
                _this.selectedMainEntity.instanceFieldSystemName = metaField.getSystemName();
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DOCUMENT) {
                _this.selectedMainEntity.documentFields.push(metaField);
            }
            if (displayNameMetaFieldIds.some(function (metaFieldId) { return metaFieldId.getSystemName() === metaField.getSystemName(); })) {
                _this.selectedMainEntity.nameMetaFieldIds.push(metaField.getMetaFieldId());
            }
        });
    };
    TableWithBulkPickerSettingsComponent.prototype.setFieldModels = function () {
        var _this = this;
        var selectedCategory = this.selectedSubEntityMetaField.getCompoundCategorySystemName();
        return this.kbService
            .getMetaFields(selectedCategory)
            .pipe(operators_1.concatMap(function (metaFields) {
            var subEntityFieldData = [];
            var linkedMainEntityFieldData = [];
            subEntityFieldData.push(of_1.of({
                // For every subEntity field creates a {displayName, CustomDraggableColumn} type object
                displayName: _this.selectedSubEntityMetaField.getDisplayNameMultilingual(),
                fields: metaFields
                    // Filters out Sub Entity Fields
                    .filter(function (field) { return field.getType() !== idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY; })
                    .map(function (field) {
                    // If a field is MainEntity type, same type of object is created, but with parentFieldName property
                    if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
                        var selectedMainEntityMetaFieldSystemNames$ = _this.kbService.getMainEntityMetaFields(_this.selectedSubEntityMetaField.getCompoundCategorySystemName(), field.getSystemName())
                            .map(function (mainEntityMetaFields) { return mainEntityMetaFields.map(function (metaField) { return metaField.getSystemName(); }); });
                        var allMainEntityMetaFields$ = _this.kbService.getMetaFields(field.getCompoundCategorySystemName());
                        // getMainEntityFields doesn't return multilingual display names, filtering all MetaFields is needed
                        linkedMainEntityFieldData.push(Observable_1.Observable.zip(allMainEntityMetaFields$, selectedMainEntityMetaFieldSystemNames$)
                            .map(function (_a) {
                            var allMetaFields = _a[0], selectedMetaFields = _a[1];
                            var fields = allMetaFields
                                .filter(function (mainEntityMetaField) {
                                return (selectedMetaFields.indexOf(mainEntityMetaField.getSystemName()) !== -1)
                                    // Filters out Sub Entity Fields
                                    && (mainEntityMetaField.getType() !== idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY);
                            })
                                .map(function (fieldEntityFields) {
                                return new custom_draggable_column_model_1.CustomDraggableColumnModel(fieldEntityFields, field.getSystemName());
                            });
                            return {
                                displayName: field.getDisplayNameMultilingual(),
                                fields: fields
                            };
                        }));
                    }
                    return new custom_draggable_column_model_1.CustomDraggableColumnModel(field, null);
                })
            }));
            return Observable_1.Observable.zip.apply(Observable_1.Observable, subEntityFieldData.concat(linkedMainEntityFieldData));
        }), operators_1.map(function (fieldData) {
            _this.subFieldModels = fieldData;
            _this.checkForUsedFields();
        }));
    };
    TableWithBulkPickerSettingsComponent.prototype.isConfiguredCorrectly = function () {
        return this.hasCorrectlyConfiguredTable() && (this.formType === idm_dynamic_layout_interpreter_1.FormType.VIEW || this.hasCorrectlyConfiguredButtons());
    };
    TableWithBulkPickerSettingsComponent.prototype.hasCorrectlyConfiguredTable = function () {
        // TODO: Add other table options later on
        return !!this.selectedSubEntityMetaField
            && !!(!(this.selectedTableType === table_type_1.TableType.hierarchical) || this.selectedGroupByMetaField)
            && !!this.selectedMainEntityMetaField
            && !!this.label.getValue(this.currentLanguageId).length
            && !!this._colSystemNames.length;
    };
    TableWithBulkPickerSettingsComponent.prototype.hasCorrectlyConfiguredButtons = function () {
        return this.buttonConfigs.every(function (buttonConfig) {
            return (!buttonConfig.searchFilter.lookupFieldSystemName || buttonConfig.searchFilter.lookupFieldValue)
                && (!buttonConfig.defaultValues.defaultValueFieldSystemName || buttonConfig.defaultValues.defaultValueFieldValue)
                && !!buttonConfig.searchKeywords.length
                && !!buttonConfig.columns.length
                && !!buttonConfig.selectedItemFields.length;
        });
    };
    TableWithBulkPickerSettingsComponent.prototype.getFieldsToLoad = function (buttonConfig) {
        var _this = this;
        var mainTableFields = [];
        if (this._colSystemNames.length && this.selectedMainEntityMetaField) {
            this._colSystemNames.forEach(function (columnInfo) {
                if (columnInfo.compoundName === _this.selectedMainEntityMetaField.getCompoundCategorySystemName()) {
                    mainTableFields.push(columnInfo.systemName);
                }
            });
        }
        var fieldsToLoad = new Set([
            this.selectedMainEntity.instanceFieldSystemName
        ].concat(this.selectedMainEntity.nameMetaFieldIds.map(function (selectedItemField) { return selectedItemField.getSystemName(); }), mainTableFields, buttonConfig.columns, buttonConfig.selectedItemFields
            .filter(function (selectedItemField) { return selectedItemField['metaCategoryId']['systemName'] === _this.selectedMainEntityMetaField.getCompoundCategorySystemName(); })
            .map(function (selectedItemField) { return selectedItemField['systemName']; })));
        if (this.mainEntityImageFieldName) {
            fieldsToLoad.add(this.mainEntityImageFieldName);
        }
        if (buttonConfig.searchFilter.lookupFieldSystemName && !fieldsToLoad.has(buttonConfig.searchFilter.lookupFieldSystemName)) {
            fieldsToLoad.add(buttonConfig.searchFilter.lookupFieldSystemName);
        }
        return Array.from(fieldsToLoad);
    };
    TableWithBulkPickerSettingsComponent.prototype.setStateValues = function () {
        this._colSystemNames = this._state['colSystemNames'];
        this.label = this._state['label'] ? new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(this._state['label']))) : null;
        this.selectedMainEntityMetaField = this._state['mainEntityMetaField'];
        this.selectedTableType = this._state['tableType'] ? this._state['tableType'] : table_type_1.TableType.simple;
        this.buttonConfigs = this._state['buttonConfigs'] ? this._state['buttonConfigs'] : [];
        this.selectedGroupByMetaField = this._state['groupByMetaField'];
        this.mainEntityImageFieldName = this._state['mainEntityImageFieldName'];
        this.selectedCustomTableActions = this._state['customTableActions'] ? this._state['customTableActions'] : [];
        this.editFormId = this._state['editFormId'];
        this.hasCustomButtons = this._state['hasCustomButtons'] ? this._state['hasCustomButtons'] : false;
        this.showDeleteButton = !!(this._state['showDeleteButton'] || this._state['showDeleteButton'] === '');
        this.useSameSearchSettings = !!(this._state['useSameSearchSettings'] || this._state['useSameSearchSettings'] === undefined);
        if (this._state['defaultButtonConfig']) {
            this.defaultButtonConfig = this._state['defaultButtonConfig'];
            this.defaultButtonConfig.title = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(this.defaultButtonConfig.stringTitle)));
        }
        else {
            this.defaultButtonConfig = table_button_config_component_1.TableButtonConfigComponent
                .getEmptyButton(this.selectedMainEntity, this.defaultButtonTitle, this.useSameSearchSettings, this.defaultButtonConfig);
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.checkForUsedFields = function () {
        var _this = this;
        if (this._colSystemNames.length) {
            this.subFieldModels.forEach(function (subFieldModel) {
                var usedSubFields = subFieldModel.fields.filter(function (field) {
                    field.disabled = false;
                    return _this._colSystemNames.some(function (col) {
                        return (col.systemName) === field.systemName && (!col.parentFieldName || col.parentFieldName === field.parentFieldName);
                    });
                });
                usedSubFields.forEach(function (field) { return field.disabled = true; });
            });
        }
    };
    TableWithBulkPickerSettingsComponent.prototype.setDefaultButtons = function () {
        this.defaultButtonConfig = table_button_config_component_1.TableButtonConfigComponent
            .getEmptyButton(this.selectedMainEntity, this.defaultButtonTitle, this.useSameSearchSettings);
        this.buttonConfigs = this.hasCustomButtons ? [] : [this.defaultButtonConfig];
    };
    TableWithBulkPickerSettingsComponent.prototype.belongsToMainEntity = function (metaFieldId) {
        return metaFieldId['metaCategoryId']
            && metaFieldId['metaCategoryId']['systemName'] === this.selectedMainEntityMetaField.getCompoundCategorySystemName();
    };
    TableWithBulkPickerSettingsComponent.prototype.overrideMetaFieldIdReferences = function (buttonConfig, metaField, isMainEntityMetaField) {
        var _this = this;
        buttonConfig.selectedItemFields.forEach(function (selectedItemFieldData, index) {
            if (selectedItemFieldData['systemName'] === metaField.getSystemName()) {
                if (isMainEntityMetaField ? _this.belongsToMainEntity(selectedItemFieldData) : !_this.belongsToMainEntity(selectedItemFieldData)) {
                    buttonConfig.selectedItemFields[index] = metaField.getMetaFieldId();
                }
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableWithBulkPickerSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableWithBulkPickerSettingsComponent.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TableWithBulkPickerSettingsComponent.prototype, "fields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], TableWithBulkPickerSettingsComponent.prototype, "state", null);
    TableWithBulkPickerSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'ejustice-table-with-bulk-picker-settings',
            template: require('./table-with-bulk-picker-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n       <ejustice-table-with-bulk-picker-settings \n            [category]=\"%{category}\"\n            [formType]=\"%{formType}\"\n            [fields]=\"%{fields}\"\n            [state]=\"%{state}\"\n            [currentLanguageId]=\"%{currentLanguageId}\"\n            [languages]=\"%{languages}\">\n      </ejustice-table-with-bulk-picker-settings>",
        }),
        __param(5, core_1.Optional()),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_dynamic_controls_metadata_1.CommunicationService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_form_management_ui_1.FormManagementService,
            idm_ng_controls_1.MessageService,
            custom_table_action_provider_service_1.CustomTableActionProviderService])
    ], TableWithBulkPickerSettingsComponent);
    return TableWithBulkPickerSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.TableWithBulkPickerSettingsComponent = TableWithBulkPickerSettingsComponent;
//# sourceMappingURL=table-with-bulk-picker-settings.component.js.map